import type { ProfileConfig } from "./types";

export const hugobossProfileConfig: ProfileConfig = {
    benefits: null,
};
